import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { SITE } from "@/data/site";

const SECTIONS = [
  {
    title: "1. Introduction",
    body: `${SITE.name} ("we," "us," or "our") respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains what information we collect through our website, how we use it, and the choices you have. By using our website or submitting a quote request, you agree to the practices described here.`,
  },
  {
    title: "2. Information We Collect",
    body: "When you submit our Free Quote Request form or contact us, we may collect your name, email address, phone number, project type, town or location, and any project details you choose to provide. We may also collect limited, non-identifying technical data (such as browser type and pages visited) to help us improve the website.",
  },
  {
    title: "3. How We Use Your Information",
    body: "We use the information you provide solely to respond to your inquiry, prepare and discuss your free estimate, schedule and complete your project, and communicate with you about your request. We do not sell, rent, or trade your personal information to third parties.",
  },
  {
    title: "4. How We Share Information",
    body: "We may share your information only with trusted team members and service providers who help us operate our business and serve you (for example, email delivery services). These parties are required to protect your information and use it only for the purposes we specify. We may also disclose information if required by law.",
  },
  {
    title: "5. Data Security",
    body: "We take reasonable administrative and technical measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.",
  },
  {
    title: "6. Your Choices",
    body: "You may request that we update or delete the personal information we hold about you at any time by contacting us using the details below. You may also opt out of non-essential communications at any time.",
  },
  {
    title: "7. Third-Party Links",
    body: "Our website may contain links to third-party websites (such as our social media pages). We are not responsible for the privacy practices of those sites and encourage you to review their policies.",
  },
  {
    title: "8. Changes to This Policy",
    body: "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.",
  },
  {
    title: "9. Contact Us",
    body: `If you have any questions about this Privacy Policy or how we handle your information, please contact us by phone at ${SITE.phoneDisplay} or by email at ${SITE.email}. We are based in ${SITE.baseCity} and serve clients throughout New Jersey.`,
  },
];

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Ardeca Construction"
        description="Read Ardeca Construction's privacy policy for quote requests, contact submissions, and website data protection in New Jersey."
        url="/privacy"
      />
      <section data-testid="privacy-header" className="bg-brand-creamSoft border-b border-brand-cream">
        <div className="container-x py-16 md:py-20">
          <p className="eyebrow">Your Privacy Matters</p>
          <h1 className="h1 mt-4">Privacy Policy</h1>
          <p className="lead mt-5 max-w-2xl">Last updated: June 2026. This page explains how {SITE.name} collects and protects your information.</p>
        </div>
      </section>

      <section className="container-x py-16 md:py-20">
        <div className="max-w-3xl">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.04}>
              <div className="mb-10">
                <h2 className="text-xl md:text-2xl font-bold text-brand-dark">{s.title}</h2>
                <p className="mt-3 text-brand-muted leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
          <div className="mt-4 rounded-2xl bg-brand-creamSoft border border-brand-cream p-6">
            <p className="text-brand-dark font-medium">Have a question about your project instead?</p>
            <Link to="/contact" data-testid="privacy-contact-link" className="btn-cta mt-4">Request a Free Quote</Link>
          </div>
        </div>
      </section>
    </>
  );
}
